import { ProductLogoData } from '@models'
import { Image } from '@media-components'

type ProductLogoImageProps = {
  logo?: ProductLogoData
  preload?: boolean
  fetchPriority?: 'high' | 'low' | 'auto'
}

export function ProductLogoImage({
  logo,
  preload,
  fetchPriority,
}: ProductLogoImageProps) {
  if (!logo?.imageData) {
    return null
  }

  return (
    <Image
      preload={preload}
      fetchPriority={fetchPriority}
      {...logo.imageData}
      sx={{
        height: logo.height ? `${logo.height}px` : undefined,
        width: logo.width ? `${logo.width}px` : undefined,
      }}
    />
  )
}
